// frontend/src/api/authApi.ts
import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

interface User {
  id: string;
  email: string;
  role: 'admin' | 'driver';
}

interface LoginResponse {
  user: User;
  token: string;
}

export const login = async (email: string, password: string): Promise<LoginResponse> => {
  const response = await api.post<LoginResponse>('/auth/login', { email, password });
  return response.data;
};
export const logout = async () => {
  await api.post('/auth/logout');
};

